/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { observer, inject } from 'mobx-react'
import Toasts from '../Toasts'
import Header from './header'
import './styles.scss'

const Layout: FC<any> = ({ setIsAuthenticated, children, title, search }) => {
  return (
    <>
      <Toasts toasts={search?.toasts} onClose={(): void => search?.popFromToasts()} />
      <Header title={title} setIsAuthenticated={setIsAuthenticated} />
      <div className="admin">{children}</div>
    </>
  )
}

export default inject('prospects', 'search')(observer(Layout))
